<script lang="ts" setup>
import {
  FieldParagraphLabelValueSidebarFieldItems,
  ParagraphLabelValueItem,
  ParagraphLabelValueSidebar,
} from '~/api/graphql/generated'
import { ItemProps } from '../components/LabelValueSidebar.vue'

const props = defineProps<{
  entity: ParagraphLabelValueSidebar
}>()

const items = computed((): ItemProps[] => {
  return (
    props.entity.fieldItems?.filter(Boolean).map((item: FieldParagraphLabelValueSidebarFieldItems) => {
      const entity = item.entity as ParagraphLabelValueItem

      return {
        label: entity.fieldLabel ?? '',
        value: entity.fieldValue?.processed ?? '',
        ...(entity.fieldDescription?.processed ? { description: entity.fieldDescription?.processed } : {}),
      }
    }) ?? []
  )
})
</script>

<template>
  <LabelValueSidebar :items="items" />
</template>
